import axios from 'axios'

const apiClient = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_ELLIS_ISLAND_URL ||
    'https://auth.stg.angelstudios.com',
})

export default apiClient
